import React, { Fragment } from "react";
import flagDE from "./images/de.png";
import flagFR from "./images/fr.png";
import flagEN from "./images/en.png";
import flagJA from "./images/ja.png";

const flags = {
  de: {
    img: flagDE,
    title: "Deutsch",
  },
  fr: {
    img: flagFR,
    title: "Français",
  },
  en: {
    img: flagEN,
    title: "English",
  },
  ja: {
    img: flagJA,
    title: "日本語",
  },
};

export const Flag = ({ locale = "en", label = false, title = false, size }) => (
  <Fragment>
    <img width={size ? 56 : 24} height={size ? 42 : 17} src={flags[locale].img} alt={`${locale} flag`} className={`flag ${size ? "large": ""}`} title={!(title === false) ? flags[locale].title : undefined}/>
    {!(label === false) && <span>{flags[locale].title}</span>}
  </Fragment>
);
